const hk = {
    'menu': ['數字貨幣', '創新與可靠', '穩定的數字資產', '為何使用BVCPay', '如何使用BVCPay'],
    'footmenu': ['首页', '关于', '联系', '其它'],
    'part1_txt1': '代表數字時代的數字貨幣',
    'part1_txt2': '全球實時的支付解決方案',
    'part1_txt3': '',
    'part1_txt4': '',
    'part1_txt5': '全球，快速，安全',
    'part1_txt6': '下載',

    'part2_txt1': '通過以下網址查詢BVCChain中的交易情況：',
    'part2_txt2': '如需商業諮詢，請發送郵件至：',
    'part2_txt11': '透過以下網址進入BVCChain的開發者平台：',
    'part2_txt22': '透過Github可獲得BVCChain開放的資源：',
    'part2_txt3': '創新可靠',
    'part2_txt4': '具有區塊鏈技術的高效及傳統貨幣的穩定',

    'part3_txt1': '穩定的數字資產',
    'part3_txt2': 'BVC將現金轉換為數字貨幣，將價值錨定或限制為本國貨幣的價格，如加元。',
    'part3_txt3': '',
    'part3_txt4': '100％支持',
    'part3_txt5': '我們實際的銀行賬戶中的加元與發行的CADT相對應以此確保兌換比例1:1，即爲1CADT=C$ 1CAD 。',
    'part3_txt6': '透明',
    'part3_txt7': '每天公布銀行資金賬目情況，及其CADT的每日交易賬本情況。',
    'part3_txt8': '安全與可信',
    'part3_txt9': 'BVC是一家金融服務公司，受加拿大金融服務部監管，具有豐富的法定和數字資產中介經驗。 CADT是BVC發行的數字資產，與加元等值。',
    'part3_txt10': '實時',
    'part3_txt11': '在BVC上可24小時數字資産交易結算。您可以將數字資産兌換爲等值的法幣，並可在3個工作日內完成兌換。',

    'part4_txt1': '為何使用BVCPay',
    'part4_txt2': '與加元等值的數字資産可兌換結算爲法幣現金',
    'part4_txt3': '更便捷、簡便地數字資産交易及轉賬流通',
    'part4_txt4': '在任何地方任何時間都可交易結算',
    'part4_txt5': '快速及時地跨境交易',
    'part4_txt6': 'BVC 是基于區塊鏈技術的開放式平台，同時確保了平台安全、公開、高效。',

    'part5_txt1': '如何使用BVCPay',
    'part5_txt2': '用戶手冊 (英文版)',
    'part5_txt3': '用戶手冊 (中文版)',
    'part5_txt4': '用戶手冊 (視頻)',
    'part5_txt5': '關於我們 (視頻)',

    'dl_txt1': 'BVC PAY',
    'dl_txt2': '基於區塊鏈科技的去中心化資產交易和支付應用',
    'dl_txt3': '安全',
    'dl_txt4': '可靠',
    'dl_txt5': '去中心化',
    'dl_txt6': '安全 可靠',
    'dl_txt7': '基于BVCChain生态体系，原生支持多资产和去中心化的资产交易',
    'dl_txt8': '去中心化',
    'dl_txt9': '所有用戶秘鑰完全由用戶保存，無中心化解決方案的弊端，百分之百保證資產交易數據的真實和資產的安全',
    'dl_txt10': '安全可靠',
    'dl_txt11': '採用BVC2L算灋，確保安全、可靠、高效',
    'dl_txt12': '可信便捷',
    'dl_txt13': '可以實时査詢歷史交易記錄，交易記錄可信和不可篡改',
    'dl_txt14': '功能介紹',
    'dl_txt15': '方便，快捷，高效',
    'dl_txt16': '資産管理',
    'dl_txt17': '可查詢多種資産持有概況',
    'dl_txt18': '資産授信、交易密碼設置',
    'dl_txt19': '交易密碼、密鑰等多重安全機制，確保資産安全',
    'dl_txt20': '資産交易',
    'dl_txt21': '資産總額、可用清晰可見',
    'dl_txt22': '可查看曆史交易明細，確保賬目清晰',
    'dl_txt23': '通過收款地址資産轉賬，方便快捷',
    'dl_txt24': '聯系人管理',
    'dl_txt25': '簡單快捷維護聯系人地址',
    'dl_txt26': '聯系人間轉賬更快速便捷',
    'dl_txt27': '可快速查詢篩選聯系人及收款地址',

    'direct_download': '直接下載'
}

export default hk